import React from 'react';
import Navbar from 'react-bootstrap/Navbar'
import NavUserOptions from './navUserOptions'

const NavBar = (props) => {
  return (
    <div className="container">
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Navbar.Brand href="/">
          <img
            src="./apex-logo.svg" // Cambia esta ruta a la ubicación correcta de tu imagen
            alt="Apex Logo"
            width="48"
            height="48"
          />
          {' '}
          {props.title}
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <NavUserOptions />
      </Navbar>
    </div>
  );
}

export default NavBar;